<template>
    <div>
        <NavigationBar :showBackButton=false @reload-appointments="getAppointments" :isReloading="pageLoader"
            :title="pageTitle" :show-reload-button="true" />
        <NotesPopup @closeDialog="hideNotes" @onConfirm="gotoBooking" :showDialog="showNotesPopup" />
        <DemoVideo v-if="showVideoModal" :showModal="showVideoModal" @close="closeDemo" />
        <ForbidAlert v-if="isForbidden" :showModal="isForbidden" :content="forbidMessage" />
        <div v-if="pageLoader" class="loader">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
        <div v-else>
            <div v-if="upcoming?.length || completed?.length || cancelled?.length" class="book-container">
                <div class="demoView" v-if="showSnackVideButton">
                    <button @click="showVideoModal = true">View demo</button>
                    <button @click="showSnackVideButton = false" style="font-weight: bold;">&#x2715;</button>
                </div>
                <div class="upcoming-appointments" v-if="upcoming?.length">
                    <p class="text upcoming-text"> Upcoming {{ '(' + upcoming.length + ')' }}</p>
                    <span v-for="token in upcoming" :key="token.appointmentId">
                        <TokenCard :cancelable="!isTimePassed(token.openingTime, token.appointmentDate)"
                            @cancel-appointment="cancelAppointment" :token="token" />
                    </span>
                </div>
                <div v-if="!upcoming?.length" class="warning-container">
                    <Notification title="No Upcoming Appointments" message="You don't have any upcoming appointments" />
                </div>
                <v-divider class="divider" v-if="upcoming?.length && completed?.length"></v-divider>
                <div class="appointments-history" v-if="completed?.length">
                    <p class="text history-text"> Appointment History</p>
                    <span v-for="token in completed" :key="token.appointmentId">
                        <TokenCard :cancelable="false" @cancel-appointment="cancelAppointment" :token="token" />
                    </span>
                </div>
                <v-divider class="divider"
                    v-if="(completed?.length || upcoming?.length) && cancelled?.length"></v-divider>
                <div class="cancelled-appointments" v-if="cancelled?.length">
                    <p class="text history-text"> Cancelled Appointments</p>
                    <span v-for="token in cancelled" :key="token.appointmentId">
                        <TokenCard :cancelable="false" :token="token" />
                    </span>
                </div>
            </div>
            <div v-if="upcoming?.length || completed?.length || cancelled?.length" class="bottom-nav-bar">
                <BookSlotButton @on-button-click="showNotes" buttonText="Book Now" />
            </div>
            <div v-if="!upcoming?.length && !completed?.length && !cancelled?.length" class="default-container">
                <img :src="imageSrc" alt="failed" />
                <p class="default-text">You do not have any booking appointment currently</p>
                <BookSlotButton @on-button-click="showNotes" buttonText="Book Now" />
                <v-btn style="width: 100%; margin-top: 16px;" color="#0054A6" @click="showVideoModal = true" outlined
                    class="custom-button">
                    View demo
                </v-btn>
            </div>
        </div>

        <v-dialog v-model="successDialogVisible" max-width="400">
            <div class="card-wrapper">
                <div class="card-top">
                    <img :src="require('@/assets/success-icon.svg')" alt="">
                    <div class="messages">
                        <p class="card-title">Appointment Cancelled Successfully</p>
                        <p class="card-message">The appointment for Token {{ selectedToken.appointmentId }} has been
                            cancelled.</p>
                    </div>
                </div>
                <div class="card-bottom">
                    <button class="ok-btn" @click="closeSuccessDialog">Ok</button>
                </div>
            </div>
        </v-dialog>

        <v-dialog v-model="failureDialogVisible" max-width="400">
            <div class="card-wrapper">
                <div class="card-top">
                    <img :src="require('@/assets/error-icon.svg')" alt="">
                    <div class="messages">
                        <p class="card-title">Appointment Cancellation Failed</p>
                        <p class="card-message">There was an error while cancelling the appointment for Token {{
                            selectedToken.appointmentId }}.</p>
                    </div>
                </div>
                <div class="card-bottom">
                    <button class="ok-btn" @click="closeFailureDialog">Ok</button>
                </div>
            </div>
        </v-dialog>
    </div>
</template>

<script>
import NavigationBar from '@/components/Navigation';
import TokenCard from '@/components/TokenCard';
import BookSlotButton from '@/components/BookSlotButton';
import Notification from '@/components/Notification.vue';
import calendarImg from '@/assets/calendar.png';
import NotesPopup from '@/components/NotesPopup.vue';
import DemoVideo from '@/components/DemoVideo.vue';
import ForbidAlert from '@/components/ForbidAlert.vue'
import { sha256, sha224 } from "js-sha256";
const VueCookies = require('vue-cookies');
const axios = require('axios');

export default {
    name: 'MyBookingsPage',
    components: {
        NavigationBar,
        TokenCard,
        BookSlotButton,
        Notification,
        NotesPopup,
        DemoVideo,
        ForbidAlert
    },
    data() {
        return {
            pageTitle: 'Bank Appointment Booking',
            selectedItem: 'Eng',
            items: ['Eng', 'Myn'],
            appointments: [],
            upcoming: [],
            completed: [],
            cancelled: [],
            imageSrc: calendarImg,
            loginToken: '',
            kbzpaytoken: '',
            urlparams: '',
            currenttime: '',
            nonce: '',
            pageLoader: false,
            dialogVisible: false,
            successDialogVisible: false,
            failureDialogVisible: false,
            selectedToken: '',
            showNotesPopup: false,
            showVideoModal: true,
            showSnackVideButton: true,
            isForbidden: false,
            forbidMessage: '',
            isCancellable: false,
            currentDateTime: new Date(),
            timeInterval: null
        };
    },
    mounted() {
        this.loginToken = VueCookies.get('loginToken');
        this.pageLoader = true;
        this.validateAndUpdate();
        this.startNewSession();
    },

    methods: {
        isTimePassed(targetTime, appointmentDate) {
            try {
                const now = this.currentDateTime;
                const currentDate = now.toISOString().split('T')[0];
                const currentHours = now.getHours();
                const currentMinutes = now.getMinutes();

                const [targetHours, targetMinutes] = targetTime.split(':').map(Number);

                let earlyTargetHours = targetHours;
                let earlyTargetMinutes = targetMinutes - 5;

                if (earlyTargetMinutes < 0) {
                    earlyTargetMinutes = 60 + earlyTargetMinutes;
                    earlyTargetHours -= 1;

                    if (earlyTargetHours < 0) {
                        earlyTargetHours = 23;
                    }
                }

                if (appointmentDate) {
                    if (currentDate > appointmentDate) {
                        return true;
                    }
                    else if (currentDate === appointmentDate) {
                        if (currentHours > earlyTargetHours) {
                            return true;
                        } else if (currentHours === earlyTargetHours && currentMinutes >= earlyTargetMinutes) {
                            return true;
                        }
                        return false;
                    }
                    return false;
                }

                if (currentHours > earlyTargetHours) {
                    return true;
                } else if (currentHours === earlyTargetHours && currentMinutes >= earlyTargetMinutes) {
                    return true;
                }

                return false;
            } catch (error) {
                console.error("Error in isTimePassed:", error);
                return true;
            }
        },
        bookSlot() {

            this.$router.push('/mybookings');

        },

        closeDemo() {
            this.$cookies.set('videoDemoSeen', 'true', '1d');
            this.showVideoModal = false;
        },

        startNewSession() {
            if (this.$cookies.get('videoDemoSeen')) {
                this.showVideoModal = false;
            } else {
                this.showVideoModal = true;
                this.$cookies.set('videoDemoSeen', 'true', '1d');
            }
        },

        hideNotes() {
            this.showNotesPopup = false;
        },

        showNotes() {
            this.showNotesPopup = true;
        },

        gotoBooking() {
            this.bookSlot();
        },

        async cancelAppointment(appointmentDetails) {
            try {
                this.selectedToken = appointmentDetails
                let appointmentData = {
                    appointmentId: appointmentDetails.appointmentId
                }
                await axios.delete(process.env.VUE_APP_BACKEND_URL + '/appointment', {
                    headers: {
                        'token': VueCookies.get('loginToken')
                    },
                    data: appointmentData
                })
                    .then((response) => {
                        this.successDialogVisible = true;
                    })
                    .catch((error) => {
                        console.log("Error while cancelling appointment", error);
                        this.failureDialogVisible = true;
                    })
            } catch (error) {
                console.log("MyBookings.CancelAppointment()", error);
            }
        },

        closeSuccessDialog() {
            this.successDialogVisible = false;
            window.location.reload();
        },

        closeFailureDialog() {
            this.failureDialogVisible = false;
            window.location.reload();
        },

        async pollAppointmentStatus(appointmentId, date) {
            const payload = {
                headers: {
                    token: VueCookies.get('loginToken')
                },
                params: {
                    appointmentId: appointmentId,
                    date: date
                }
            };
            const response = await axios.get(process.env.VUE_APP_BACKEND_URL + "/appointment/poll", payload);
            
            return response.data.status === 'ACTIVE'
        },

        scheduleRecurringCallsInTimeRange(startTime, endTime, targetDate, payload) {
            if (!targetDate) {
                const today = new Date();
                targetDate = today.getFullYear() + '-' +
                    String(today.getMonth() + 1).padStart(2, '0') + '-' +
                    String(today.getDate()).padStart(2, '0');
            }

            const [startHour, startMinute] = startTime.split(':').map(Number);
            const [endHour, endMinute] = endTime.split(':').map(Number);

            let intervalId = null;
            const self = this;

            function checkTimeAndExecute() {
                const now = new Date();
                const currentDate = now.getFullYear() + '-' +
                    String(now.getMonth() + 1).padStart(2, '0') + '-' +
                    String(now.getDate()).padStart(2, '0');

                if (currentDate !== targetDate) {
                    clearInterval(intervalId);
                    return;
                }

                const currentHour = now.getHours();
                const currentMinute = now.getMinutes();

                const currentTimeInMinutes = currentHour * 60 + currentMinute;
                const startTimeInMinutes = startHour * 60 + startMinute;
                const endTimeInMinutes = endHour * 60 + endMinute;

                if (currentTimeInMinutes >= startTimeInMinutes && currentTimeInMinutes <= endTimeInMinutes) {
                    self.pollAppointmentStatus(payload.appointmentId, payload.appointmentDate)
                    .then((isActive) => {
                        if (!isActive) {
                            self.getAppointments()
                            clearInterval(intervalId);
                        }
                    })
                    .catch((error) => {
                        clearInterval(intervalId);
                    });
                } else if (currentTimeInMinutes > endTimeInMinutes) {
                    clearInterval(intervalId);
                }
            }

            console.log(`Scheduler started for date: ${targetDate}, time range: ${startTime} to ${endTime}`);
            checkTimeAndExecute();
            intervalId = setInterval(checkTimeAndExecute, 30000);

            return {
                stop: function () {
                    if (intervalId !== null) {
                        clearInterval(intervalId);
                        console.log('Scheduler manually stopped.');
                    }
                }
            };
        },

        async getAppointments() {
            this.pageLoader = true;
            axios.get(process.env.VUE_APP_BACKEND_URL + "/appointment/userId",
                {
                    headers: {
                        'token': VueCookies.get('loginToken'),
                    },
                }).then((getAppointmentByUserIdResponse) => {
                    let data = getAppointmentByUserIdResponse.data.data;
                    this.upcoming = data.Upcoming;
                    this.cancelled = data.Cancelled;
                    this.completed = data.History;
                    this.pageLoader = false;
                    if (this.upcoming.length > 0) {
                        const [activeAppointmentDetails] = this.upcoming;
                        const { openingTime, closingTime, appointmentDate } = activeAppointmentDetails;
                        this.scheduleRecurringCallsInTimeRange(openingTime, closingTime, appointmentDate, activeAppointmentDetails)
                    }
                })
                .catch((getAppointmentByUserIdError) => {
                    if (getAppointmentByUserIdError?.response?.status == 403) {
                        this.isForbidden = true;
                        this.showVideoModal = false;
                        this.forbidMessage = getAppointmentByUserIdError.response.data.message;
                    }
                    console.log("[ERROR] in GetAppointmentbyUserId", getAppointmentByUserIdError);
                })
        },

        async tokenValidation() {
            await axios.get(process.env.VUE_APP_BACKEND_URL + "/token",
                {
                    headers: {
                        'token': VueCookies.get('loginToken'),
                    }
                }
            ).then((tokenValidationResponse) => {
                if (tokenValidationResponse.status == 200) {
                    return true;
                }
                else {
                    return false;
                }
            })
                .catch((error) => {
                    console.log("MyBookings.tokenValidation()", error)
                    return false;
                })
        },

        async validateAndUpdate() {
            if (this.loginToken) {
                let isTokenValid = this.tokenValidation();
                if (isTokenValid) {
                    this.getAppointments();
                }

            } else {
                this.kbzpaytoken = this.$route.query.kbzpay_token;
                this.urlparams = this.$route.query.kbzpay_token;
                this.currenttime = Math.floor(new Date().getTime() / 1000);
                this.nonce = this.generaterandomstring(32);

                this.biz_content = {
                    merch_code: process.env.VUE_APP_MERCH_CODE,
                    appid: process.env.VUE_APP_APP_ID,
                    trade_type: "APPH5",
                    access_token: this.urlparams,
                    resource_type: "OPENID",
                };

                var signstring =
                    "access_token=" +
                    this.urlparams +
                    "&appid=" +
                    process.env.VUE_APP_APP_ID +
                    "&merch_code=" +
                    process.env.VUE_APP_MERCH_CODE +
                    "&method=kbz.payment.queryCustInfo" +
                    "&nonce_str=" +
                    this.nonce +
                    "&resource_type=OPENID" +
                    "&timestamp=" +
                    this.currenttime +
                    "&trade_type=APPH5&version=1.0&key=" +
                    process.env.VUE_APP_MERCH_KEY;

                this.shastring = sha256(signstring);

                var requestdata = {
                    Request: {
                        method: "kbz.payment.queryCustInfo",
                        timestamp: String(this.currenttime),
                        nonce_str: this.nonce,
                        sign_type: "SHA256",
                        sign: this.shastring,
                        version: "1.0",
                        biz_content: this.biz_content,
                    },
                };
                axios
                    .post(process.env.VUE_APP_BACKEND_URL + "/login/kbzpay", requestdata)
                    .then((kbzpayLoginResponse) => {
                        // if (kbzpayLoginResponse.data.level == "not allowed") {
                        //     // this.levelModal = true;
                        // }
                        this.loginToken = kbzpayLoginResponse.data.token;
                        this.$cookies.set('loginToken', this.loginToken);
                        this.getAppointments();
                        //this.pageLoader = false;
                    })
                    .catch((error) => {
                        console.log('Error in kbzpayLoginResponse', error);
                    })
            }
        },

        generaterandomstring(length) {
            var result = "";
            var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
            var charactersLength = characters.length;
            for (var i = 0; i < length; i++) {
                result += characters.charAt(
                    Math.floor(Math.random() * charactersLength)
                );
                this.nonce = result;
                return result;
            }
        }
    }
};
</script>

<style scoped>
.container {
    padding: 0;
}

.book-container {
    margin-top: 56px;
    padding-bottom: 56px;
    padding-bottom: 56px;
}

.upcoming-appointments,
.appointments-history,
.cancelled-appointments {
    padding: 16px 16px 0 16px;
}


.loader {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}

.bottom-nav-bar {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 56px;
    background-color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 16px;
}

.text {
    font-size: 16px;
    line-height: 16px;
}

.upcoming-text {
    color: #0054A6;
}

.divider {
    margin-top: 11px;
    border-top: 5px solid #BDBDBD;
}

.default-container {
    padding: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: calc(100vh - 56px);
}

.default-text {
    padding: 0 14px;
    text-align: center;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    margin-top: 10px;
}

.warning-container {
    padding: 16px;
}

.v-card__title {
    word-break: break-word;
}

.card-wrapper {
    width: 100%;
    height: auto;
    background-color: #fff;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    align-items: center;
    justify-content: center;
}

.card-top,
.card-body {
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: center;
    justify-content: center;
}

.card-title {
    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: center;
    color: #333;
}

.card-message {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: center;
    color: #333;
}

.ok-btn {
    background: #0055B1;
    color: white;
    padding: 8px 12px;
    border-radius: 4px;
}

.demoView {
    padding: 8px 16px;
    background-color: rgba(0, 84, 166, 0.2);
    color: rgb(0, 84, 166);
    display: flex;
    justify-content: space-between;
}
</style>